import React, { useState, useEffect } from 'react';
import axios from 'axios';

// componentes
import { useHistory, useParams } from "react-router-dom";
import { Card, Form, Row, Col, Button, Badge } from 'react-bootstrap';
import MaskedInput from 'react-maskedinput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import useIsMounted from 'ismounted';
import TextoSms from './../../ModelosSms/Cadastrar/TextoSms';
import ParametrosSms from './ParametrosSms';
import ComboModeloSms from './../../Componentes/ComboModeloSms';

// componente
export default function EnviarSms({
    aniversariante='N'
}){

    // estados, 
    const isMounted = useIsMounted();
    let history = useHistory();
    let { idade, id, idcliente } = useParams();
    let [dados, alterarDados] = useState({
        id: id || null,
        id_cliente: idcliente || null,
        mensagem: '',
        celular: '',
        data_agendado: null,
        tipo_aniversariante: aniversariante,
        idade_referencia: idade || null,
        flashsms: 'N'
    });
    let [dadosCliente, alterarDadosCliente] = useState(null);
    let [carregando, alterarCarregando] = useState(true);
    let [salvando, alterarSalvando] = useState(false);
    let [erro, alterarErro] = useState(null);

    // referências
    let telCelInput = React.createRef();

    // inicializa
    useEffect(() => {

        // verifica se é edição ou cadastro
        if(id){

            // consulta os dados do sms enviado, e já retorna os dados do cliente

        }else{

            // consulta os dados do cliente
            axios.get(`/clientes/${dados.id_cliente}`)
            .then(({data, ...retorno}) => {
                console.log(data.dados);
                alterarDados({
                    ...dados,
                    celular: data.dados.telefone_celular
                });
                alterarDadosCliente(data.dados);
            })
            .catch(e => {})
            .then(() => {
                alterarCarregando(false);
            });
        }


    }, []);

    // faz o envio
    function salvar(){

        // envia
        alterarSalvando(true);

        // faz a requisição
        axios.post(`/clientes/enviarSms`, dados)
        .then(({data, ...retorno}) => {

            // mensagem de cadastro realizado com sucesso
            toast(({closeToast }) => <>
                <div className="toast-header">
                    <strong className="mr-auto">Sms registrado para envio!</strong>
                    <button 
                        onClick={closeToast} 
                        className="ml-2 mb-1 close btn-outline-light outline-0"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="toast-body">
                    {dadosCliente.nome}
                </div>
            </>);

            // vai para a consulta de sms's enviados (por enquanto volta para a consulta de clientes)
            history.push('/painel/sms');

        })
        .catch(e => {

            // encontrou erros
            
        })
        .then(() => {
            if (isMounted.current) {
                alterarSalvando(false);
            }
        });

    }

    // carregar modelo de email com as informaões do cliente
    function carregarModelo(idModelo){

        // faz a requisição para carregar o modelo com os dados do cliente
        axios.get(`/modelosSms/${idModelo}/convertido/${dados.id_cliente}`)
        .then(({data, ...retorno}) => {
            dados.mensagem = data.mensagem;
            alterarDados({ ...dados });
        })
    }

    // se estiver carregando
    if(carregando){
        return <>Carregando ...</>
    }

    return <>

        <Row>
            <Col lg={8}>
                <Card className={'border-0 shadow-sm'}>
                    <Card.Header className={'bg-white border-0'}>
                        <Card.Title as='h4'>Enviar SMS</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <Form.Row>
                            <Col lg={8}>
                                <Form.Label>Nome</Form.Label>
                                <p>{dadosCliente.nome}</p>
                            </Col>
                            <Col lg={4}>
                                <Form.Label>Celular</Form.Label>
                                <MaskedInput 
                                    className="form-control"
                                    mask="(11) 11111-1111"
                                    value={dados.celular}
                                    ref={telCelInput}
                                    onChange={(e) => {
                                        alterarDados({...dados, celular: telCelInput.current.mask.getRawValue().split('_').join('')});
                                    }}
                                />
                            </Col>
                        </Form.Row>

                        <Form.Group>
                            <Form.Label>Mensagem</Form.Label>
                            <TextoSms 
                                value={dados.mensagem}
                                onChange={e => {
                                    dados.mensagem = e.target.value;
                                    alterarDados({...dados});
                                }}
                                maxLength={200}
                            />
                        </Form.Group>
                        <p className={'text-right'}>
                            <span>Caracteres </span>
                            <Badge
                                variant={dados.mensagem.length > 160 ? 'danger' : 'info'}
                            >
                                {dados.mensagem.length}
                            </Badge>
                        </p>
                    </Card.Body>
                </Card>

                <Form.Group className="d-flex justify-content-around my-4">
                    <Button variant="danger" onClick={() => {
                        history.goBack();
                    }}>
                        <span>Cancelar</span>
                    </Button>
                    <Button variant="success" disabled={salvando} onClick={salvar}>
                        {salvando ? 
                            <>
                                <FontAwesomeIcon className="icone" pulse icon={["fas", 'spinner']} />
                                <span>Enviando</span>
                            </> : 
                            <span>Enviar sms</span>
                        }
                    </Button>
                </Form.Group>
            </Col>
            <Col lg={4}>
                <Card className={'border-0 shadow-sm'}>
                    <Card.Body>
                        <ParametrosSms 
                            dados={dados}
                            alterarDados={alterarDados}
                        />

                        { dados.mensagem === '' && 
                            <ComboModeloSms 
                                alterou={carregarModelo}
                            />
                        }
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    </>

    

}